import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ApiHandlerService } from '../api-handler.service'
import { Router } from '@angular/router';

declare let $:any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  menuList = [];
  @Output() postCall = new EventEmitter<any>();
  constructor(private apiHandler: ApiHandlerService, private route: Router) { }

  ngOnInit() {
    $(document).on('mouseover','.resources-header', function(){
      $(".dropdown-resources").css('display', 'block')
    })
    $(document).on("mouseleave", ".resources-header", function() {
      $(".dropdown-resources").css('display', 'none')
    })
    $(document).on('mouseover','.events-header', function(){
      $(".events-dropdown").css('display', 'block')
    })
    $(document).on("mouseleave", ".events-header", function() {
      $(".events-dropdown").css('display', 'none')
    })
    this.getMenuList()
  }

  getMenuList(){
    this.apiHandler.getMenuList().subscribe(
      (result:any) => {
        this.menuList = result.data;
    },
    err=>{
      console.error("Become partner Error ==>", err);
      
    }
    )
  }

  navigateResource(menu){
    let slug = menu.slug?menu.slug:"all"
    $(".dropdown-content").css('display', 'none');
    this.postCall.emit({slug:menu.slug});
    this.route.navigate(['/resources/'+slug])

  }

}
